module.exports = __webpack_public_path__ + "search-white-58e6d3ff76731ddd8d96.svg";